module.exports = __webpack_public_path__ + "static/media/selieda.43c00687.png";